import axios from 'axios';

import store from '@/store/store';

import { appActions } from "@/store/actions/app.actions";

const api = axios.create({
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
		'accept': 'application/json',
	},
	crossdomain: true,
});

api.interceptors.request.use(config => {
	config.baseURL = `${store.getState().app.config.reactAppApi}/api`;
	config.headers = {
		...config.headers,
		Authorization: store.getState().auth.csrf,
		// Language: store.getState().app.currentLang, 
		// 'X-CSRF-TOKEN': .credentials.csrf, 
	};
	return config;
}, function (error) {
	return Promise.reject(error);
},
);

api.interceptors.response.use(response => response,
	error => {
		if (error.response && !error.config.ignoreRedirectInterceptors) {
			switch (error.response.status) {
				case 403:
					sessionStorage.clear();
					store.dispatch(appActions.setError(403));
					break;
				case 404:
					store.dispatch(appActions.setError(404));
					break;
				case 500:
					store.dispatch(appActions.setError(500));
					break;
				default:
					return Promise.reject(error);
			}
			return Promise.reject(error);
		}

		return Promise.reject(error);
	},
);

export default api;

/* ---
*   How to use api service:
*   - import api service into a file -> import 'services/api.js';
*   - GET method -> api.get('url').then((response) => ...).catch((error) => ...)
*   - POST method -> api.post('url', { data }).then((response) => ...).catch((error) => ...)
*   - PUT method -> api.put('url', { data }).then((response) => ...).catch((error) => ...)
*
*   Remember: PUT for UPDATE operations, POST for CREATE operations.
* ---
*/
